<div class="scope" [class.scope--empty]="isEmpty()" role="status">
  @if (isAll()) {
    <b>{{ 'SCOPE.ALL' | translate }}</b>
  } @else if (isEmpty()) {
    <i class="fa-solid fa-triangle-exclamation" aria-hidden="true"></i>
    <b>{{ 'SCOPE.EMPTY' | translate }}</b>
    <span class="scope__hint">{{ 'SCOPE.EMPTY_HINT' | translate }}</span>
  } @else {
    <b>{{ 'SCOPE.COUNT' | translate: { subjects: subjectCount(), levels: levels().length } }}</b>
    <ul class="scope__levels">
      @for (l of levels(); track l.id) {
        <li><span class="scope__level">{{ l.title }}</span> — {{ l.subjects.join(', ') }}</li>
      }
    </ul>
  }
</div>
